import React, { useEffect, useState } from "react";
import * as Converter from "persian-currency-converter";
import Grid from "@mui/material/Grid";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import Axios from "axios";
import { ErrorsTab } from "../../models/cartable.model";
import ShowErrorsModal from "../../components/modals/ShowErrorModal";

export default function InstallmentCheck(props: any) {
    let data = props.data;
    return (
        <>
            <div id="cheque">
                {props.data[0]?.cheque! ?
                    <Grid item xs={12} style={{ marginTop: "1.5vh" }}>
                        <div
                            className="cardTableBorder"
                            style={{ minHeight: "30vh" }}
                        >
                            <TableContainer style={{ background: "#fff" }}>
                                <Table
                                    stickyHeader
                                    aria-label="sticky table"
                                    style={{ borderCollapse: "collapse" }}
                                >
                                    <TableHead
                                        className="rowTHead"
                                        style={{ paddingBottom: "10px" }}
                                    >
                                        <TableRow className="borderRight borderLeft">
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="right"
                                                style={{ width: "1vh", minWidth: "1vh", maxWidth: "1vh" }}
                                            >
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="right"
                                                style={{ width: "8vh", minWidth: "8vh" }}
                                            >
                                                ردیف
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                تاریخ سررسید
                                            </TableCell>

                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                دروجه
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                مبلغ به عدد(ریال)
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                امضا کننده
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                شناسه ملی
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                سری و سریال چک
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                شماره صیادی
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                شماره شبا
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                بانک / کد شعبه
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <div
                                        style={{ width: "100%", height: "10px" }}
                                    ></div>
                                    <TableBody>
                                        {/* {initialValues.items?.map((row: any, rowIndex: any) => { */}
                                        {data?.map((row: any, rowIndex: any) => {
                                            return (
                                                <TableRow
                                                    className={`${rowIndex % 2 == 0
                                                        ? "rowTBodyE  borderRight borderLeft"
                                                        : "rowTBodyO  borderRight borderLeft"
                                                        }`}
                                                    hover
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={row.value}
                                                >
                                                    {row.accumulativeLoaded ?
                                                        <TableCell className="accumulativeColor textFont12 colorFFF    " style={{ width: "1vh", minWidth: "1vh", maxWidth: "1vh" }}>
                                                            <p style={{
                                                                transform: 'rotate(-90deg) translateX(10px)', display: 'flex', transformOrigin: 'center',
                                                                alignItems: 'center', verticalAlign: 'middle'
                                                            }}>تجمیعی</p>
                                                        </TableCell> :
                                                        <TableCell style={{ width: "1vh", minWidth: "1vh", maxWidth: "1vh" }}>
                                                        </TableCell>}
                                                    <TableCell className="textFont12" style={{ width: "8vh", minWidth: "8vh" }}>
                                                        {
                                                            rowIndex + 1
                                                        }
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.installments[0].dueDate_Persian}</span>

                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.cheque.expectedHolder}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        {row.accumulativeLoaded ?
                                                            <span>{row.cheque.accumulativeAmount.toLocaleString()}</span> :
                                                            <span>{row.installments[0].amount.toLocaleString()}</span>
                                                        }
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.cheque.signer}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.cheque.expectedIdCode}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.cheque.serialNo}/{row.cheque.seriesNo}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.cheque.sayadNumber}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.cheque.fromIban}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.cheque.bankName}_کد{row.cheque.bankCode}</span>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </Grid >
                    :
                    <Grid item xs={12} style={{ marginTop: "1.5vh" }}>
                        <div
                            className="cardTableBorder"
                            style={{ minHeight: "30vh" }}
                        >
                            <TableContainer style={{ background: "#fff" }}>
                                <Table
                                    stickyHeader
                                    aria-label="sticky table"
                                    style={{ borderCollapse: "collapse" }}
                                >
                                    <TableHead
                                        className="rowTHead"
                                        style={{ paddingBottom: "10px" }}
                                    >
                                        <TableRow className="borderRight borderLeft">
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="right"
                                                style={{ width: "10vh", minWidth: "10vh" }}
                                            >
                                                ردیف
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                شماره قسط
                                            </TableCell>

                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                تاریخ سررسید
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                تاریخ پرداخت
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                مبلغ به عدد(ریال)
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                اصل
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                فرع
                                            </TableCell>
                                            <TableCell
                                                className="rowTHead colorTitle textFont14 "
                                                align="center"
                                            >
                                                جریمه
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <div
                                        style={{ width: "100%", height: "10px" }}
                                    ></div>
                                    <TableBody>
                                        {/* {initialValues.items?.map((row: any, rowIndex: any) => { */}
                                        {data?.map((row: any, rowIndex: any) => {
                                            return (
                                                <TableRow
                                                    className={`${rowIndex % 2 == 0
                                                        ? "rowTBodyE  borderRight borderLeft"
                                                        : "rowTBodyO  borderRight borderLeft"
                                                        }`}
                                                    hover
                                                    role="checkbox"
                                                    tabIndex={-1}
                                                    key={row.value}
                                                >
                                                    <TableCell className="textFont12">
                                                        {
                                                            rowIndex +
                                                            1}
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>قسط شماره {Converter.convertToPersianWord(row.installments[0].rowNumber)}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.installments[0].dueDate_Persian}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.installments[0].paymentDatePersian}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className="textFont12 nowrapClass"
                                                        align="right"
                                                    >
                                                        <span>{row.installments[0].amount.toLocaleString()}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className={`${row.workflowStepType == "Forward" ? "SuccessDefaultFont textFont12" : " DangerDefaultFont textFont12"}`}
                                                        align="right"
                                                    >
                                                        <span>{row.installments[0].mainAmount.toLocaleString()}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className={`${row.workflowStepType == "Forward" ? "SuccessDefaultFont textFont12" : " DangerDefaultFont textFont12"}`}
                                                        align="right"
                                                    >
                                                        <span>{row.installments[0].profitAmount.toLocaleString()}</span>
                                                    </TableCell>
                                                    <TableCell
                                                        className={`${row.workflowStepType == "Forward" ? "SuccessDefaultFont textFont12" : " DangerDefaultFont textFont12"}`}
                                                        align="right"
                                                    >
                                                        <span>{row.installments[0].penaltyAmount.toLocaleString()}</span>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </Grid >
                }
            </div>
        </>
    );
}
